import axios from "axios";

let logoutCallback = null;

export const setLogoutCallback = (callback) => {
  logoutCallback = callback;
};

export const api = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT_URL,
  //timeout: 1000,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json, text/plain, */*",
  },
});

api.interceptors.request.use((config) => {
  const user = localStorage.getItem("user");
  if (user) {
    const token = JSON.parse(user).token;
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for handling 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (logoutCallback) {
        logoutCallback(); // Call the logout function
      }
      return Promise.reject(error); // Return the error, don't chain the next interceptor
    } else {
      return Promise.reject(error); // Pass the error back to the interceptor
    }
  }
);
